import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { PhoneNumberAudit } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-phone-number-audit-list',
  templateUrl: './person-profile-phone-number-audit-list.component.html',
  styleUrls: ['./person-profile-phone-number-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfilePhoneNumberAuditListComponent implements OnInit {
  @Input() phoneNumberId: number;
  @Input() loading: boolean;
  @Input() phoneNumberAudits: PhoneNumberAudit[];

  @Output() loadPhoneNumberAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadPhoneNumberAudits.emit(this.phoneNumberId);
  }

  onNextPage() {
    this.nextPage.emit(this.phoneNumberId);
  }
}
